import React from 'react';
import styled from 'styled-components';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { FaInfoCircle as FaInfoCircleRaw } from 'react-icons/fa';
import MarketingHeader from '../components/MarketingHeader';
import { MarketingPageShell, Table, PrimaryButton, SecondaryButton } from '../styles/marketingSharedStyles';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const FaInfoCircle: any = FaInfoCircleRaw;

const PageWrap = styled.div`
  min-height: 100%;
  background: var(--background);
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-bottom: 1rem;
  overflow-x: clip;
`;

const Content = styled(MarketingPageShell).attrs({ as: 'main' })`
  margin-top: 1rem;
`;

const PageTitle = styled.h1`
  margin: 0 0 0.25rem 0;
  font-size: clamp(1.35rem, 2.3vw, 1.85rem);
  font-weight: 700;
  color: var(--onSurface);
`;

const PageSub = styled.p`
  margin: 0 0 1.5rem 0;
  font-size: 0.95rem;
  color: var(--onSurfaceVariant);
`;

const KpiGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 1rem;
  margin-bottom: 1.5rem;
  @media (max-width: 960px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

const KpiCard = styled.div`
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.04) 0%, rgba(255, 255, 255, 0.01) 100%), var(--surface);
  border: 1px solid var(--outline);
  border-radius: 16px;
  padding: 1.25rem;
  box-shadow: 0 14px 30px rgba(0, 0, 0, 0.16);
  min-width: 0;
`;

const KpiLabel = styled.div`
  font-size: 0.75rem;
  font-weight: 600;
  color: var(--onSurfaceVariant);
  text-transform: uppercase;
  letter-spacing: 0.04em;
  margin-bottom: 0.35rem;
`;

const KpiValue = styled.div`
  font-size: clamp(1.2rem, 2vw, 1.65rem);
  font-weight: 700;
  color: var(--onSurface);
  margin-bottom: 0.35rem;
`;

const KpiChange = styled.span<{ $positive: boolean }>`
  display: inline-block;
  font-size: 0.8rem;
  font-weight: 600;
  padding: 0.15rem 0.4rem;
  border-radius: 4px;
  background: ${({ $positive }) => ($positive ? 'var(--successContainer)' : 'var(--errorContainer)')};
  color: ${({ $positive }) => ($positive ? 'var(--success)' : 'var(--error)')};
  margin-bottom: 0.5rem;
`;

const KpiBar = styled.div`
  height: 4px;
  background: var(--outline);
  border-radius: 2px;
  overflow: hidden;
`;

const KpiBarFill = styled.div<{ $pct: number }>`
  height: 100%;
  width: ${({ $pct }) => Math.min(100, $pct)}%;
  background: var(--primary);
  border-radius: 2px;
`;

const SectionCard = styled.section`
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.035) 0%, rgba(255, 255, 255, 0.01) 100%), var(--surface);
  border: 1px solid var(--outline);
  border-radius: 16px;
  padding: 1.25rem;
  margin-bottom: 1.5rem;
  box-shadow: 0 16px 34px rgba(0, 0, 0, 0.14);
  min-width: 0;
`;

const SectionHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 0.75rem;
  margin-bottom: 1.25rem;
  @media (max-width: 768px) {
    > div {
      width: 100%;
      display: grid !important;
      grid-template-columns: 1fr;
    }
  }
`;

const SectionTitle = styled.h2`
  margin: 0;
  font-size: 1.1rem;
  font-weight: 600;
  color: var(--onSurface);
`;


const FunnelSteps = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.5rem;
  margin-bottom: 1rem;
  min-width: 0;
`;

const FunnelStepCard = styled.div`
  background: var(--surfaceVariant);
  border: 1px solid var(--primary);
  border-radius: 14px;
  padding: 1rem 1.25rem;
  min-width: 0;
  flex: 1 1 220px;
  text-align: center;
`;

const FunnelStepLabel = styled.div`
  font-size: 0.7rem;
  font-weight: 600;
  color: var(--onSurfaceVariant);
  text-transform: uppercase;
  letter-spacing: 0.03em;
  margin-bottom: 0.35rem;
`;

const FunnelStepValue = styled.div`
  font-size: 1.25rem;
  font-weight: 700;
  color: var(--onSurface);
`;

const FunnelStepPct = styled.div`
  font-size: 0.8rem;
  color: var(--onSurfaceVariant);
  margin-top: 0.25rem;
`;

const DropBadge = styled.span`
  display: inline-block;
  font-size: 0.75rem;
  font-weight: 600;
  color: var(--error);
  background: var(--errorContainer);
  padding: 0.2rem 0.5rem;
  border-radius: 4px;
  margin: 0 0.25rem;
`;

const TwoColGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1.5rem;
  @media (max-width: 900px) {
    grid-template-columns: 1fr;
  }
`;

const DropOffPct = styled.span`
  color: var(--error);
  font-weight: 600;
`;

const SectionTitleRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 1rem;
`;

const ViewAllLink = styled.button`
  border: none;
  background: none;
  color: var(--primary);
  font-size: 0.9rem;
  font-weight: 600;
  cursor: pointer;
  padding: 0;
  &:hover {
    text-decoration: underline;
  }
`;

const EngagementList = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
`;

const EngagementItem = styled.li`
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.75rem 0;
  border-bottom: 1px solid var(--outline);
  font-size: 0.9rem;
  &:last-child {
    border-bottom: none;
  }
`;

const Avatar = styled.div`
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: var(--surfaceVariant);
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--onSurfaceVariant);
  font-size: 0.85rem;
`;

const EngagementDetail = styled.div`
  flex: 1;
  min-width: 0;
`;

const EngagementPhone = styled.div`
  font-weight: 500;
  color: var(--onSurface);
`;

const EngagementMeta = styled.div`
  font-size: 0.8rem;
  color: var(--onSurfaceVariant);
  margin-top: 0.15rem;
`;

const StatusPill = styled.span<{ $variant: 'completed' | 'in_progress' | 'dropped' }>`
  display: inline-block;
  font-size: 0.7rem;
  font-weight: 600;
  padding: 0.2rem 0.5rem;
  border-radius: 999px;
  flex-shrink: 0;
  background: ${({ $variant }) =>
    $variant === 'completed' ? 'var(--successContainer)' : $variant === 'in_progress' ? 'var(--warningContainer)' : 'var(--errorContainer)'};
  color: ${({ $variant }) =>
    $variant === 'completed' ? 'var(--success)' : $variant === 'in_progress' ? 'var(--warning)' : 'var(--error)'};
`;

const MOCK_DROP_OFF = [
  { reason: 'Invalid Keyword', count: 4320, pct: 35 },
  { reason: 'Unsubscribe during flow', count: 3110, pct: 25 },
  { reason: 'Carrier Filtering', count: 2840, pct: 23 },
  { reason: 'Timed Out (No response)', count: 2060, pct: 17 },
];

const MOCK_ENGAGEMENT = [
  { phone: '+1 (555) 012-3456', detail: "Matched: 'JOIN' • 2m ago", status: 'completed' as const },
  { phone: '+1 (555) 012-3457', detail: "Matched: 'HELP' • 15m ago", status: 'in_progress' as const },
  { phone: '+1 (555) 012-3458', detail: "Error: 'NOPE' • 1h ago", status: 'dropped' as const },
  { phone: '+1 (555) 012-3459', detail: "Matched: 'JOIN' • 2h ago", status: 'completed' as const },
  { phone: '+1 (555) 012-3460', detail: 'Timed out • 3h ago', status: 'dropped' as const },
];

export default function FunnelAnalyticsPage() {
  const totalStarted = 24480;
  const keywordMatches = 18920;
  const completedFlow = 12150;

  return (
    <PageWrap>
      <MarketingHeader activeTab="funnels" />

      <Content>
        <PageTitle>Funnel Analytics</PageTitle>
        <PageSub>
          Track subscriber conversion steps and identify high drop-off points in your automated SMS
          workflows.
        </PageSub>

        <KpiGrid>
          <KpiCard>
            <KpiLabel>Total Started</KpiLabel>
            <KpiValue>{totalStarted.toLocaleString()}</KpiValue>
            <KpiChange $positive={true}>+12.5%</KpiChange>
            <KpiBar>
              <KpiBarFill $pct={100} />
            </KpiBar>
          </KpiCard>
          <KpiCard>
            <KpiLabel>Keyword Matches</KpiLabel>
            <KpiValue>{keywordMatches.toLocaleString()}</KpiValue>
            <KpiChange $positive={true}>+5.2%</KpiChange>
            <KpiBar>
              <KpiBarFill $pct={77} />
            </KpiBar>
          </KpiCard>
          <KpiCard>
            <KpiLabel>Completed Flow</KpiLabel>
            <KpiValue>{completedFlow.toLocaleString()}</KpiValue>
            <KpiChange $positive={false}>-2.1%</KpiChange>
            <KpiBar>
              <KpiBarFill $pct={50} />
            </KpiBar>
          </KpiCard>
        </KpiGrid>

        <SectionCard>
          <SectionHeader>
            <SectionTitle>Workflow: Welcome Sequence (V2)</SectionTitle>
            <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
              <SecondaryButton type="button">Last 30 Days</SecondaryButton>
              <PrimaryButton type="button">Export Report</PrimaryButton>
            </div>
          </SectionHeader>
          <FunnelSteps>
            <FunnelStepCard>
              <FunnelStepLabel>Step 1: Opt-in Received</FunnelStepLabel>
              <FunnelStepValue>24,480</FunnelStepValue>
              <FunnelStepPct>100% of starts</FunnelStepPct>
            </FunnelStepCard>
            <DropBadge>-22.7% Drop</DropBadge>
            <FunnelStepCard>
              <FunnelStepLabel>Step 2: Keyword Match</FunnelStepLabel>
              <FunnelStepValue>18,920</FunnelStepValue>
              <FunnelStepPct>77.3% conversion</FunnelStepPct>
            </FunnelStepCard>
            <DropBadge>-35.8% Drop</DropBadge>
            <FunnelStepCard>
              <FunnelStepLabel>Step 3: Flow Completed</FunnelStepLabel>
              <FunnelStepValue>12,150</FunnelStepValue>
              <FunnelStepPct>49.6% total CR</FunnelStepPct>
            </FunnelStepCard>
          </FunnelSteps>
        </SectionCard>

        <TwoColGrid>
          <SectionCard>
            <SectionTitleRow>
              <SectionTitle style={{ marginBottom: 0 }}>
                Drop-off Reasons
                <FaInfoCircle
                  size={14}
                  style={{ marginLeft: '0.35rem', color: 'var(--onSurfaceVariant)', verticalAlign: 'middle' }}
                  title="Reasons subscribers left the workflow"
                />
              </SectionTitle>
            </SectionTitleRow>
            <Table>
              <thead>
                <tr>
                  <th>Reason</th>
                  <th>Count</th>
                  <th>% Total</th>
                </tr>
              </thead>
              <tbody>
                {MOCK_DROP_OFF.map((row) => (
                  <tr key={row.reason}>
                    <td>{row.reason}</td>
                    <td>{row.count.toLocaleString()}</td>
                    <td>
                      <DropOffPct>{row.pct}%</DropOffPct>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </SectionCard>

          <SectionCard>
            <SectionTitleRow>
              <SectionTitle style={{ marginBottom: 0 }}>Recent Engagement</SectionTitle>
              <ViewAllLink type="button">View All</ViewAllLink>
            </SectionTitleRow>
            <EngagementList>
              {MOCK_ENGAGEMENT.map((item, i) => (
                <EngagementItem key={i}>
                  <Avatar>👤</Avatar>
                  <EngagementDetail>
                    <EngagementPhone>{item.phone}</EngagementPhone>
                    <EngagementMeta>{item.detail}</EngagementMeta>
                  </EngagementDetail>
                  <StatusPill $variant={item.status}>
                    {item.status === 'completed'
                      ? 'COMPLETED'
                      : item.status === 'in_progress'
                        ? 'IN PROGRESS'
                        : 'DROPPED'}
                  </StatusPill>
                </EngagementItem>
              ))}
            </EngagementList>
          </SectionCard>
        </TwoColGrid>
      </Content>
    </PageWrap>
  );
}
